// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"091ec6b83e1abaf9","3337":"6df38bd2579ac123","3481":"6df38bd2579ac123","4494":"6df38bd2579ac123","9579":"6df38bd2579ac123"}[chunkId] + ".css";
};